import { HttpMethod, PagingQuery } from "~/extensions/api";
export class FindAppliedListCommand extends PagingQuery {
    constructor(userCd) {
        super(HttpMethod.Get, `taikyonotification/applied/list/find/${userCd}`);
    }
}
